import React from "react";

const Search: React.FC = () => {
  return <h1>Search Page</h1>;
};

export default Search;
